import React from 'react'
import PropTypes from 'prop-types'
import reducer, { loadTax } from '../state'
import l10n from '../../../shared/l10n'
import { classNames } from '../../../util/classNames'

const {
  overviews,
  common: { trending },
} = l10n

class DhsvBlogTaxListing extends React.Component {
  constructor(props) {
    super(props)
    this.state = reducer()
    this.dispatch = this.dispatch.bind(this)
    this.loadTax = this.loadTax.bind(this)
    this.changeSelect = this.changeSelect.bind(this)
  }

  componentDidMount() {
    this.loadTax()
  }

  dispatch(action) {
    if (typeof action === 'function') {
      action(this.dispatch, () => this.state)
    } else {
      this.setState(prevState => reducer(prevState, action))
    }
  }

  loadTax() {
    const { type } = this.props
    this.dispatch(loadTax({ type }))
  }

  changeSelect(e) {
    if (e.target.value === 'all') {
      window.location = window.location.origin + '/' + overviews.magazine
    } else {
      this.props.handleCategoryChange(e.target.value)
      // window.location = e.target.value
    }
  }

  hasSubArray(master, sub) {
    return sub.every(i => master.indexOf(i) >= 0)
  }

  render() {
    const { data } = this.state
    const {
      title,
      type,
      categories,
      sBrowser,
      handleCategoryChange,
      taxCombinations,
      current,
    } = this.props

    if (current !== undefined && current.id) {
      categories.push(current.id)
    }

    // Detect the inactive state of the item
    data.map(tax => {
      tax.isInactive = false
      // ignore if no active items or current item is already active
      if (categories.length > 0 && categories.indexOf(tax.id) == -1) {
        // Predict the combination for the current item and try to find it along the available combinations
        let result = taxCombinations.filter(item => {
          return this.hasSubArray(item, [...categories, tax.id])
        })
        tax.isInactive = result.length == 0
      }
      return tax
    })

    // Get the default/selected value
    data.map(item => {
      if (categories !== undefined) {
        item.isActive = categories.indexOf(item.id) > -1
      }

      item.preselected =
        current !== undefined && current.id && item.id == current.id
    })

    return data.length > 0 ? (
      <div className="tax_wrapper">
        <div className="title-toggle-wrapper">
          <span className="title">
            {trending} {title}:
          </span>
          {sBrowser.lessThan.lg ? (
            <button
              className={classNames([
                `tax-toggle`,
                this.state.wrapTax && 'active',
              ])}
              onClick={() => this.dispatch({ type: 'TOGGLE_WRAP_TAX' })}
            ></button>
          ) : null}
        </div>
        {sBrowser.lessThan.lg ? (
          <div className="mobile-tax-wrapper">
            <ul
              className={classNames([
                `-${type} mobile-tax`,
                this.state.wrapTax && 'active',
              ])}
            >
              {data.map((item, index) => (
                <li
                  key={index}
                  className={item.isActive ? 'current-item' : null}
                >
                  <a
                    className={item.isInactive ? 'is-disabled' : ''}
                    href={item.isActive ? '/' + overviews.magazine : item.link}
                    onClick={e => {
                      if (!item.preselected) {
                        e.preventDefault()
                        !item.isInactive && handleCategoryChange(item.id)
                      }
                    }}
                  >
                    {item.name}
                    {item.isActive && <i className="icon ion-close" />}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <ul className={`-${type}`}>
            {data.map((item, index) => (
              <li key={index} className={item.isActive ? 'current-item' : null}>
                <a
                  className={item.isInactive ? 'is-disabled' : ''}
                  href={item.isActive ? '/' + overviews.magazine : item.link}
                  onClick={e => {
                    if (!item.preselected) {
                      e.preventDefault()
                      !item.isInactive && handleCategoryChange(item.id)
                    }
                  }}
                >
                  {item.name}
                  {item.isActive && <i className="icon ion-close" />}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    ) : null
  }
}

DhsvBlogTaxListing.propTypes = {
  sBrowser: PropTypes.object,
  title: PropTypes.string,
  type: PropTypes.string,
  categories: PropTypes.array,
  handleCategoryChange: PropTypes.func,
  taxCombinations: PropTypes.array,
  current: PropTypes.object,
}

export default DhsvBlogTaxListing
